import dynamic from 'next/dynamic';
import { type FC, type JSX, type ReactNode } from 'react';

import { type PageAuth } from '@/src/components-v2/types';
import { UrqlProvider } from '@/src/features/integrations/urql/providers';
import { PageAuthType } from '@/src/middleware/pages';

import { BootstrappedAuthenticatedUserProvider } from './BootstrappedAuthenticatedUserProvider';

const LtiAuthenticatedUserProvider = dynamic(
  () => import('./LtiAuthenticatedUserProvider').then(mod => mod.LtiAuthenticatedUserProvider),
  { ssr: false },
);

export interface AuthenticatedUserProviderProps {
  readonly auth: PageAuth<PageAuthType.Auth0> | PageAuth<PageAuthType.Lti>;
  readonly children: ReactNode;
}

export const AuthenticatedUserProvider: FC<AuthenticatedUserProviderProps> = ({
  children,
  ...props
}): JSX.Element => {
  switch (props.auth.type) {
    case PageAuthType.Auth0:
      return (
        <UrqlProvider isLti={false}>
          <BootstrappedAuthenticatedUserProvider auth={props.auth}>
            {children}
          </BootstrappedAuthenticatedUserProvider>
        </UrqlProvider>
      );
    case PageAuthType.Lti:
      return (
        <UrqlProvider isLti>
          <LtiAuthenticatedUserProvider auth={props.auth}>{children}</LtiAuthenticatedUserProvider>
        </UrqlProvider>
      );
  }
};
